<template>
  <div class="account_download">
    <div class="account_download__title">PURCHASED DOWNLOADS</div>
    <div
      v-for="i in 3"
      :key="i"
      class="bg-white rounded-10px account_download__item"
      :class="$vuetify.breakpoint.width <= 650 ? 'wrap' : ''"
    >
      <div class="d-flex gap-14">
        <div class="account_download__image">
          <img />
        </div>
        <div class="d-flex flex-column">
          <div class="text-poppins-15 font-weight-600">
            I Thought We Were Having Fun
          </div>
          <div class="text-poppins-15 text-grey-1">RUCKAZOID, Tri Nohbi</div>
        </div>
      </div>

      <div
        class="d-flex align-center mr-3 wrap"
        :class="$vuetify.breakpoint.width <= 1280 ? 'gap-18' : 'gap-36'"
      >
        <div class="cursor-pointer text-poppins-15">Download</div>
        <div class="text-poppins-13">3 remaining</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccountDownload",
};
</script>



// WEBPACK FOOTER //
// account_download.vue?dfc7b710